module.exports = __webpack_public_path__ + "img/avater.9f94ae1b.png";